import { render, staticRenderFns } from "./ZipcodeAdd.vue?vue&type=template&id=327e17c8"
import script from "./ZipcodeAdd.vue?vue&type=script&lang=js"
export * from "./ZipcodeAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports